export const defineFooterButtonsStyle = (setupMFA: boolean) => ({
  display: 'flex',
  padding: '0.5rem 0 0',
  justifyContent: 'flex-end',
  alignitems: 'flex-start',
  gap: setupMFA ? '24px' : '16px',
  alignSelf: 'stretch',
  width: '100%'
})